<template>
    <small @click="mailGroupChangeBusOn">
        <div class="text-muted">
            <span>
                <small>
                    <i v-if="item.email_flg == '0'" class="fas fa-circle text-success"></i>
                    <i v-else class="fas fa-circle text-danger"></i>&nbsp;
                </small>
            </span>
            <span>{{item.name}}</span>
            <span v-if="type == 'user' && item.first_nm">
                <span>（{{item.first_nm}}{{item.last_nm}}）</span>
            </span>
            <span v-if="type == 'user' && item.cmp_group">
                <span class="text-dark">（営業:{{item.cmp_group}}）</span>
            </span>
        </div>
        <div class="text-muted">
            <div v-if="type == 'user'" class="text-right">
                <span v-if="item.company_nm">{{item.company_nm}}</span>
            </div>
            <div v-else-if="type == 'partner'">
                <span>lv.{{item.email_lev}}</span>
                <span class="border px-1">{{item.user_group}}</span>
                <span v-if="item.country" class="border px-1">{{item.country}}</span>
                <span v-if="item.sales_name" class="border border-primary px-1">{{item.sales_name}}</span>
                <span v-if="item.sales_mail" class="border border-success px-1">to</span>
                <span v-if="item.sales_mail_cc" class="border border-success px-1">cc</span>
            </div>
        </div>
        <div>
        </div>
        <div v-if="item.email_group != this.$route.params.group" class="text-danger">
            <span class="text-muted">変更後：</span>
            <span v-if="item.email_group == 'tech'">技術者</span>
            <span v-else-if="item.email_group == 'company'">法人</span>
            <span v-else-if="item.email_group == 'partner'">パートナー</span>
            <span v-else>{{item.group_nm}}</span>
        </div>
    </small>
</template>

<script>
    import {EventBus} from 'js/event-bus'

    export default {
        props: {
            type: String,
            item: Object
        },
        methods: {
            mailGroupChangeBusOn () {
                EventBus.$emit('mailGroupChange', this.type, this.item)
            }
        }

    }

</script>

<style>

</style>
